document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('salesforce-form');
  
  if (form) {
    // Add validation styling on input change
    form.querySelectorAll('input[required], select[required], textarea[required]').forEach(field => {
      field.addEventListener('invalid', function(e) {
        e.preventDefault();
        this.classList.add('invalid');
        const errorMessage = this.closest('.form-group').querySelector('.error-message');
        if (errorMessage) {
          errorMessage.style.display = 'block';
        }
      });

      field.addEventListener('input', function() {
        if (this.checkValidity()) {
          this.classList.remove('invalid');
          const errorMessage = this.closest('.form-group').querySelector('.error-message');
          if (errorMessage) {
            errorMessage.style.display = 'none';
          }
        }
      });
    });

    // Handle form submission
    form.addEventListener('submit', async function(event) {
      event.preventDefault();
      
      // Reset previous error states
      form.querySelectorAll('.invalid').forEach(field => {
        field.classList.remove('invalid');
      });
      form.querySelectorAll('.error-message').forEach(msg => {
        msg.style.display = 'none';
      });

      // Check validity
      let isValid = true;
      form.querySelectorAll('input[required], select[required], textarea[required]').forEach(field => {
        if (!field.checkValidity()) {
          isValid = false;
          field.classList.add('invalid');
          const errorMessage = field.closest('.form-group').querySelector('.error-message');
          if (errorMessage) {
            errorMessage.style.display = 'block';
          }
        }
      });

      if (!isValid) {
        return;
      }

      try {
        const formData = new FormData(form);
        const response = await fetch(form.action, {
          method: 'POST',
          body: formData,
          mode: 'no-cors'
        });

        // Show thank you message
        document.querySelector('.initial-state').classList.add('display-none');
        document.getElementById('form-wrapper').classList.add('display-none');
        document.getElementById('thank-you').classList.remove('display-none');
        
        // Reset form
        form.reset();
      } catch (error) {
        console.error("Form submission error:", error);
        // Show error message to user
        alert(form.dataset.errorMessage || 'There was an error submitting the form. Please try again.');
      }
    });
  }
});

document.addEventListener('DOMContentLoaded', function() {
  const scrollToThankYou = () => {
    const thankYouElement = document.getElementById("thank-you");
    if (thankYouElement && !thankYouElement.classList.contains('display-none')) {
      let target = thankYouElement.offsetTop;
      window.scrollTo({ top: target, behavior: "smooth" });
    }
  };

  // Call scrollToThankYou after showing the thank you message
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.target.id === 'thank-you' && 
          !mutation.target.classList.contains('display-none')) {
        scrollToThankYou();
      }
    });
  });

  const thankYouElement = document.getElementById('thank-you');
  if (thankYouElement) {
    observer.observe(thankYouElement, { 
      attributes: true, 
      attributeFilter: ['class'] 
    });
  }
});